import React, { useEffect } from 'react';
import { Descriptions, Form, Input, InputNumber, Modal } from 'antd';
import { entityConfig } from './backendChartAdapter';

export default function EntityEditModal({ node, creation, onCancel, onSave }) {
    const [form] = Form.useForm();
    const entityType = creation?.entityType || node?.data.entityType;
    const config = entityConfig[entityType];
    const record = node?.data.record;

    useEffect(() => {
        if (node || creation) {
            form.resetFields();
            if (node) form.setFieldsValue({ name: node.data.name, code: node.data.code, resources: record.pos_resource_total });
        }
    }, [node, creation, record, form]);

    return (
        <Modal title={`${creation ? 'Add' : 'Edit'} ${config?.label || 'unit'}`} open={!!node || !!creation} onCancel={onCancel}
            okText={creation ? 'Add unit' : 'Apply changes'} onOk={() => form.submit()}>
            {creation && <p>Parent: {creation.parentName || 'None (root organization)'}</p>}
            <Form form={form} layout="vertical" onFinish={values => onSave(node?.id, values)}>
                <Form.Item name="name" label="Name" rules={[{ required: true, whitespace: true }]}>
                    <Input maxLength={256} />
                </Form.Item>
                <Form.Item name="code" label="Code" rules={[{ required: ['department', 'position'].includes(entityType), whitespace: true }]}>
                    <Input maxLength={config?.codeLength || 16} />
                </Form.Item>
                {entityType === 'position' && (
                    <Form.Item name="resources" label="Total resources">
                        <InputNumber min={0} max={2147483647} precision={0} />
                    </Form.Item>
                )}
            </Form>
            {!creation && <Descriptions size="small" column={1}>
                <Descriptions.Item label="Status">{record?.is_active == null ? 'Unspecified' : record.is_active ? 'Active' : 'Inactive'}</Descriptions.Item>
                {node?.data.entityType === 'organization' && <>
                    <Descriptions.Item label="Address">{record.org_address || '—'}</Descriptions.Item>
                    <Descriptions.Item label="Contact">{record.org_contact_person || '—'}</Descriptions.Item>
                    <Descriptions.Item label="Phone">{record.org_contact_no || '—'}</Descriptions.Item>
                    <Descriptions.Item label="Efficiency factor">{record.org_efficiency_factor ?? '—'}</Descriptions.Item>
                </>}
            </Descriptions>}
        </Modal>
    );
}
